import type { Dispatch } from 'redux';

import { actionResetAdBudgetPurchased } from 'src/app/v1/state/modules/tealium/adBudgetPurchased';
import { actionResetAdBudgetValue } from 'src/app/v1/state/modules/tealium/adBudgetValue';
import { actionResetAdvertiser } from 'src/app/v1/state/modules/tealium/advertiser';
import { actionResetAutoClassifyCategoryChosen } from 'src/app/v1/state/modules/tealium/autoClassifyCategoryChosen';
import { actionResetAutoClassifyCategorySuggested } from 'src/app/v1/state/modules/tealium/autoClassifyCategorySuggested';
import { actionResetCajaAboutBusinessCharacterCount } from 'src/app/v1/state/modules/tealium/cajaAboutBusinessCharacterCount';
import { actionResetCajaFlowType } from 'src/app/v1/state/modules/tealium/cajaFlowType';
import { actionResetCajaHasAIAssistanceBeenUsed } from 'src/app/v1/state/modules/tealium/cajaHasAIAssistanceBeenUsed';
import { actionResetCajaPayType } from 'src/app/v1/state/modules/tealium/cajaPayType';
import { actionResetCajaSalaryCurrency } from 'src/app/v1/state/modules/tealium/cajaSalaryCurrency';
import { actionResetCajaWorkType } from 'src/app/v1/state/modules/tealium/cajaWorkType';
import { actionResetContractProductName } from 'src/app/v1/state/modules/tealium/contractProductName';
import { actionResetContractProductSetProductId } from 'src/app/v1/state/modules/tealium/contractProductSetProductId';
import { actionResetCountry } from 'src/app/v1/state/modules/tealium/country';
import { actionResetDiscountCode } from 'src/app/v1/state/modules/tealium/discountCode';
import { actionResetTrackingDisplayPay } from 'src/app/v1/state/modules/tealium/displayPay';
import { actionResetDraftId } from 'src/app/v1/state/modules/tealium/draftId';
import { actionResetEmailAddressVerified } from 'src/app/v1/state/modules/tealium/emailAddressVerified';
import { actionResetExperiments } from 'src/app/v1/state/modules/tealium/experiments';
import { actionResetFinalJobSummaryCharacterCount } from 'src/app/v1/state/modules/tealium/finalJobSummaryCharacterCount';
import { actionResetHasCoverImage } from 'src/app/v1/state/modules/tealium/hasCoverImage';
import { actionResetHasLogo } from 'src/app/v1/state/modules/tealium/hasLogo';
import { actionResetHasSeenSuccess } from 'src/app/v1/state/modules/tealium/hasSeenSuccess';
import { actionResetHirerAdPurchaser } from 'src/app/v1/state/modules/tealium/hirerAdPurchaser';
import { actionResetHirerContract } from 'src/app/v1/state/modules/tealium/hirerContract';
import { actionResetHirerInfo } from 'src/app/v1/state/modules/tealium/hirerInfo';
import { actionResetHirerPurchaseType } from 'src/app/v1/state/modules/tealium/hirerPurchaseType';
import { actionResetHubbleExperiments } from 'src/app/v1/state/modules/tealium/hubbleExperiments';
import { actionResetIsLinkOutApplyViaSeek } from 'src/app/v1/state/modules/tealium/isLinkOutApplyViaSeek';
import { actionResetIsOnCreditHold } from 'src/app/v1/state/modules/tealium/isOnCreditHold';
import { actionResetIsPaidByStoredCreditCard } from 'src/app/v1/state/modules/tealium/isPaidByStoredCreditCard';
import { actionResetIsPayment } from 'src/app/v1/state/modules/tealium/isPayment';
import { actionResetIsPremiumAdOffered } from 'src/app/v1/state/modules/tealium/isPremiumAdOffered';
import { actionResetIsPrivateAd } from 'src/app/v1/state/modules/tealium/isPrivateAd';
import { actionResetIsSaveCreditCardChecked } from 'src/app/v1/state/modules/tealium/isSaveCreditCardChecked';
import { actionResetJobAdClassification } from 'src/app/v1/state/modules/tealium/jobAdClassification';
import { actionResetJobAdPostedWithRR } from 'src/app/v1/state/modules/tealium/jobAdPostedWithRR';
import { actionResetJobAdSubClassification } from 'src/app/v1/state/modules/tealium/jobAdSubClassification';
import { actionResetJobAdTypePosted } from 'src/app/v1/state/modules/tealium/jobAdTypePosted';
import { actionResetJobAdTypeSelected } from 'src/app/v1/state/modules/tealium/jobAdTypeSelected';
import { actionResetNumberOfBenefits } from 'src/app/v1/state/modules/tealium/numberOfBenefits';
import { actionResetNumberOfQualifications } from 'src/app/v1/state/modules/tealium/numberOfQualifications';
import { actionResetNumberOfTasks } from 'src/app/v1/state/modules/tealium/numberOfTasks';
import { actionResetOrderNumber } from 'src/app/v1/state/modules/tealium/orderNumber';
import { actionResetPage } from 'src/app/v1/state/modules/tealium/page';
import { actionResetPaymentMediumSelected } from 'src/app/v1/state/modules/tealium/paymentMediumSelected';
import { actionResetPaymentMethod } from 'src/app/v1/state/modules/tealium/paymentMethod';
import { actionResetPreviousPageName } from 'src/app/v1/state/modules/tealium/previousPageName';
import { actionResetPriceVisibility } from 'src/app/v1/state/modules/tealium/priceVisibility';
import { actionResetProductPricing } from 'src/app/v1/state/modules/tealium/productPricing';
import { actionResetProductSetId } from 'src/app/v1/state/modules/tealium/productSetId';
import { actionResetProductSetProductIds } from 'src/app/v1/state/modules/tealium/productSetProductIds';
import { actionResetProductTotalPrice } from 'src/app/v1/state/modules/tealium/productTotalPrice';
import { actionResetRecommendedSalaryRange } from 'src/app/v1/state/modules/tealium/recommendedSalaryRange';
import { actionResetRoleTitle } from 'src/app/v1/state/modules/tealium/roleTitle';
import { actionResetRRNumberOfQuestions } from 'src/app/v1/state/modules/tealium/rrNumberOfQuestions';
import { actionResetRRQuestionIds } from 'src/app/v1/state/modules/tealium/rrQuestionIds';
import { actionResetSalaryRangeSelected } from 'src/app/v1/state/modules/tealium/salaryRangeSelected';
import { actionResetSeekAdvertiserId } from 'src/app/v1/state/modules/tealium/seekAdvertiserId';
import { actionResetSeekListingId } from 'src/app/v1/state/modules/tealium/seekListingId';
import { actionResetSourceJobId } from 'src/app/v1/state/modules/tealium/sourceJobId';
import { actionResetTestingId } from 'src/app/v1/state/modules/tealium/testingId';
import { actionResetUserId } from 'src/app/v1/state/modules/tealium/userId';

export default () => (dispatch: Dispatch) => {
  dispatch(actionResetDiscountCode());
  dispatch(actionResetContractProductName());
  dispatch(actionResetContractProductSetProductId());
  dispatch(actionResetAdBudgetPurchased());
  dispatch(actionResetAdBudgetValue());
  dispatch(actionResetAdvertiser());
  dispatch(actionResetAutoClassifyCategoryChosen());
  dispatch(actionResetAutoClassifyCategorySuggested());
  dispatch(actionResetCajaAboutBusinessCharacterCount());
  dispatch(actionResetCajaFlowType());
  dispatch(actionResetCajaHasAIAssistanceBeenUsed());
  dispatch(actionResetCajaPayType());
  dispatch(actionResetCajaSalaryCurrency());
  dispatch(actionResetCajaWorkType());
  dispatch(actionResetCountry());
  dispatch(actionResetDraftId());
  dispatch(actionResetEmailAddressVerified());
  dispatch(actionResetExperiments());
  dispatch(actionResetFinalJobSummaryCharacterCount());
  dispatch(actionResetHasCoverImage());
  dispatch(actionResetHasLogo());
  dispatch(actionResetHasSeenSuccess());
  dispatch(actionResetHirerAdPurchaser());
  dispatch(actionResetHirerContract());
  dispatch(actionResetHirerInfo());
  dispatch(actionResetHirerPurchaseType());
  dispatch(actionResetHubbleExperiments());
  dispatch(actionResetIsLinkOutApplyViaSeek());
  dispatch(actionResetIsOnCreditHold());
  dispatch(actionResetIsPaidByStoredCreditCard());
  dispatch(actionResetIsPremiumAdOffered());
  dispatch(actionResetIsPrivateAd());
  dispatch(actionResetIsPayment());
  dispatch(actionResetIsSaveCreditCardChecked());
  dispatch(actionResetJobAdClassification());
  dispatch(actionResetJobAdPostedWithRR());
  dispatch(actionResetJobAdSubClassification());
  dispatch(actionResetJobAdTypePosted());
  dispatch(actionResetJobAdTypeSelected());
  dispatch(actionResetNumberOfBenefits());
  dispatch(actionResetNumberOfQualifications());
  dispatch(actionResetNumberOfTasks());
  dispatch(actionResetOrderNumber());
  dispatch(actionResetPage());
  dispatch(actionResetPaymentMediumSelected());
  dispatch(actionResetPaymentMethod());
  dispatch(actionResetPreviousPageName());
  dispatch(actionResetPriceVisibility());
  dispatch(actionResetProductPricing());
  dispatch(actionResetProductSetId());
  dispatch(actionResetProductSetProductIds());
  dispatch(actionResetProductTotalPrice());
  dispatch(actionResetRecommendedSalaryRange());
  dispatch(actionResetRoleTitle());
  dispatch(actionResetRRNumberOfQuestions());
  dispatch(actionResetRRQuestionIds());
  dispatch(actionResetSalaryRangeSelected());
  dispatch(actionResetSeekAdvertiserId());
  dispatch(actionResetSeekListingId());
  dispatch(actionResetSourceJobId());
  dispatch(actionResetTestingId());
  dispatch(actionResetTrackingDisplayPay());
  dispatch(actionResetUserId());
};
